// extracted by mini-css-extract-plugin
module.exports = {"container":"TextImageSection_container__pn5MQ","content":"TextImageSection_content__vSV93","figure":"TextImageSection_figure__loJqc"};